// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/**
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
.range-slider .range-bar-active {
  background: black !important;
}

.range-md .range-knob-handle .range-pin {
  transform: translate3d(0, 0, 0) scale(1) !important;
}

.range-md:not(.range-has-pin) .range-knob-handle .range-knob {
  transform: scale(1) !important;
}

.range-ios .range-knob-handle .range-pin {
  transform: translate3d(0, 0, 0) scale(1) !important;
}

.dialog-background {
  filter: blur(3px);
  position: fixed;
  z-index: -1;
}

.ag-plot-zoom {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 99999;
}

.ag-plot-no-zoom {
  padding: 10px;
  position: relative;
}

.ag-plot-legend {
  font-size: 14px;
  margin-top: 10px;
}
.ag-plot-legend .ag-legend-item {
  margin: 2px 5px;
  display: inline-flex;
}
.ag-plot-legend .ag-legend-item .ag-legend-icon {
  align-self: center;
  margin-right: 5px;
  width: 10px;
  height: 10px;
  border-radius: 45px;
}

.cellular-device-overview {
  padding: 8px 4px 4px;
  _overflow-x: hidden;
  _overflow-y: auto;
}
.cellular-device-overview .ag-value-header {
  font-size: 16px;
  font-weight: bold;
}
.cellular-device-overview .ag-value-section {
  margin-left: 5px;
}
.cellular-device-overview .ag-values-row {
  margin: 12px 0 4px 0;
  _align-self: center;
}
.cellular-device-overview .ag-values-row .ag-value-row {
  overflow: hidden;
  width: 150px;
}
.cellular-device-overview .ag-values-row .ag-value-row .icon {
  width: 32px;
  height: 32px;
  margin: 0;
}
.cellular-device-overview .ag-values-row .ag-value-row .ag-value {
  _height: 32px;
  font-size: 24px;
  _line-height: 32px;
  _text-align: center;
}
.cellular-device-overview .ag-values-row .ag-value-row .ag-value-label {
  font-size: 12px;
}
.cellular-device-overview .stats-container {
  padding: 16px;
}
.cellular-device-overview .temp-row,
.cellular-device-overview .amb-temp-row {
  margin-bottom: 8px;
}
.cellular-device-overview .temp-row md-icon,
.cellular-device-overview .amb-temp-row md-icon {
  width: 32px;
  height: 32px;
  margin: 0;
}
.cellular-device-overview .temp-row .temp-value,
.cellular-device-overview .amb-temp-row .temp-value {
  height: 32px;
  margin-left: 4px;
  font-size: 32px;
  font-weight: 500;
  line-height: 36px;
}
.cellular-device-overview .temp-row md-icon {
  fill: #ed6d05;
}
.cellular-device-overview .temp-row .temp-value {
  color: #ed6d05;
}
.cellular-device-overview .amb-temp-row md-icon {
  fill: #3498db;
}
.cellular-device-overview .amb-temp-row .temp-value {
  color: #3498db;
}
.cellular-device-overview .temp-label {
  margin-left: 4px;
  color: #303c42;
}
.cellular-device-overview .temp-ts {
  color: #303c42;
}
.cellular-device-overview ._ag-card {
  /*background: white;
  _margin-bottom: 10px;
  margin: 8px;
  border: 2px solid #fff;
  border-radius: 16px;
  position: relative;*/
  margin-bottom: 10px;
  _border: 2px solid #fff;
  border-radius: 8px;
  margin: 8px;
  flex: 1 0 auto;
  background-color: #fff;
  box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12);
}
.cellular-device-overview .flex-auto {
  flex: 1 0 auto !important;
}
.cellular-device-overview #device-map {
  height: 280px;
}
.cellular-device-overview #device-map md-toast {
  z-index: 2000;
}
.cellular-device-overview .temp-history-container {
  width: 100%;
  _height: 260px;
  padding-top: 0;
  /*@media (min-width: \$layout-breakpoint-sm) {
    height: 280px;
    padding-top: 8px;
  }*/
}

.cellular-expand-button {
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 1000;
  width: 32px !important;
  min-width: 32px !important;
  height: 32px !important;
  min-height: 32px !important;
  padding: 0 !important;
  margin: 0 !important;
  line-height: 20px;
}
.cellular-expand-button md-icon,
.cellular-expand-button ng-md-icon {
  width: 20px;
  min-width: 20px;
  height: 20px;
  min-height: 20px;
  font-size: 20px;
  color: rgba(0, 0, 0, 0.87);
}

#map-expand-button {
  background-color: #fff;
}
#map-expand-button md-icon,
#map-expand-button ng-md-icon {
  color: #000;
}

#get-location-button {
  position: absolute;
  right: 8px;
  bottom: 20px;
  z-index: 1000;
  width: 32px;
  min-width: 32px;
  height: 32px;
  min-height: 32px;
  padding: 0 !important;
  margin: 0 !important;
  line-height: 20px;
  background-color: #fff;
}
#get-location-button md-icon,
#get-location-button ng-md-icon {
  width: 20px;
  min-width: 20px;
  height: 20px;
  min-height: 20px;
  font-size: 20px;
  color: #000;
}

#cellular-chart-card {
  _margin-top: 16px;
  _margin-bottom: 16px;
}
#cellular-chart-card .chart-heading {
  margin: 10px 5px;
  _align-self: center;
  padding-bottom: 0;
  _margin: 8px 0 0 8px;
  font-weight: 600;
  color: #303c42;
}

.tb-fullscreen-parent > #cellular-chart-card {
  margin: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/components/cellular-spear/spear-overview.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;;;;;;;;;;;;;;EAAA;AAkBE;EACE,4BAAA;AADJ;;AAKA;EACE,mDAAA;AAFF;;AAIA;EACE,8BAAA;AADF;;AAGA;EACE,mDAAA;AAAF;;AAEA;EACI,iBAAA;EACA,eAAA;EACA,WAAA;AACJ;;AAGA;EACE,eAAA;EAAiB,WAAA;EAAa,YAAA;EAC9B,MAAA;EAAQ,OAAA;EAAS,cAAA;AAInB;;AAFA;EACE,aAAA;EAAe,kBAAA;AAMjB;;AAHA;EACE,eAAA;EACA,gBAAA;AAMF;AALE;EACE,eAAA;EACA,oBAAA;AAOJ;AALI;EACE,kBAAA;EACA,iBAAA;EACA,WAAA;EAAa,YAAA;EAAc,mBAAA;AASjC;;AALC;EACE,oBAAA;GAQD,kBAPC;GAQD,gBAPC;AAQH;AANG;EACE,eAAA;EACA,iBAAA;AAQL;AANG;EACE,gBAAA;AAQL;AANG;EACC,oBAAA;GAQF,kBAPE;AAQJ;AAPI;EACE,gBAAA;EACA,YAAA;AASN;AARM;EACE,WAAA;EACA,YAAA;EACA,SAAA;AAUR;AAPM;GASJ,YARM;EACA,eAAA;GASN,iBARM;GASN,kBARM;AASR;AAPM;EACE,eAAA;AASR;AAJG;EACE,aAAA;AAML;AAHG;;EAEE,kBAAA;AAKL;AAHK;;EACE,WAAA;EACA,YAAA;EACA,SAAA;AAMP;AAHK;;EACE,YAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAMP;AADK;EACE,aAAA;AAGP;AAAK;EACE,cAAA;AAEP;AAGK;EACE,aAAA;AADP;AAIK;EACE,cAAA;AAFP;AAMG;EACE,gBAAA;EACA,cAAA;AAJL;AAOG;EACE,cAAA;AALL;AAQG;EACE;;;;;sBAAA;EAMA,mBAAA;GANH,sBAOE;EACA,kBAAA;EACA,WAAA;EACA,cAAA;EACA,sBAAA;EACA,gHAAA;AANJ;AAQG;EACE,yBAAA;AANL;AASG;EACE,aAAA;AAPL;AASK;EACE,aAAA;AAPP;AAWG;EACE,WAAA;GATH,aAUG;EACA,cAAA;EAEA;;;IAAA;AAPL;;AAcC;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,0BAAA;EACA,uBAAA;EACA,2BAAA;EACA,qBAAA;EACA,oBAAA;EACA,iBAAA;AAXH;AAaG;;EAEE,WAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,0BAAA;AAXL;;AAeC;EACE,sBAAA;AAZH;AAcG;;EAEE,WAAA;AAZL;;AAgBC;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;EACA,qBAAA;EACA,oBAAA;EACA,iBAAA;EACA,sBAAA;AAbH;AAeG;;EAEE,WAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;AAbL;;AAiBC;GAdC,gBAeC;GAdD,mBAeC;AAdH;AAgBG;EACC,gBAAA;GAdF,kBAeE;EACA,iBAAA;GAdF,mBAeG;EACA,gBAAA;EACA,cAAA;AAdL;;AAkBC;EACE,SAAA;AAfH","sourcesContent":["/**\r\n * Copyright © 2016-2020 The Thingsboard Authors\r\n *\r\n * Licensed under the Apache License, Version 2.0 (the \"License\");\r\n * you may not use this file except in compliance with the License.\r\n * You may obtain a copy of the License at\r\n *\r\n *     http://www.apache.org/licenses/LICENSE-2.0\r\n *\r\n * Unless required by applicable law or agreed to in writing, software\r\n * distributed under the License is distributed on an \"AS IS\" BASIS,\r\n * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.\r\n * See the License for the specific language governing permissions and\r\n * limitations under the License.\r\n */\r\n\r\n\r\n.range-slider {\r\n  .range-bar-active {\r\n    background: black !important;\r\n  }\r\n}\r\n\r\n.range-md .range-knob-handle .range-pin {\r\n  transform: translate3d(0, 0, 0) scale(1) !important; }\r\n\r\n.range-md:not(.range-has-pin) .range-knob-handle .range-knob {\r\n  transform: scale(1) !important; }\r\n\r\n.range-ios .range-knob-handle .range-pin {\r\n  transform: translate3d(0, 0, 0) scale(1) !important; }\r\n\r\n.dialog-background {\r\n    filter: blur(3px);\r\n    position: fixed;\r\n    z-index: -1;\r\n}\r\n\r\n\r\n.ag-plot-zoom {\r\n  position: fixed; width: 100%; height: 100%;\r\n  top: 0; left: 0; z-index: 99999;\r\n}\r\n.ag-plot-no-zoom  {\r\n  padding: 10px; position: relative;\r\n}\r\n\r\n.ag-plot-legend {\r\n  font-size: 14px;\r\n  margin-top: 10px;\r\n  .ag-legend-item {\r\n    margin: 2px 5px;\r\n    display: inline-flex;\r\n\r\n    .ag-legend-icon {\r\n      align-self: center;\r\n      margin-right: 5px;\r\n      width: 10px; height: 10px; border-radius: 45px;\r\n    }\r\n  }\r\n}\r\n .cellular-device-overview {\r\n   padding: 8px 4px 4px;\r\n   _overflow-x: hidden;\r\n   _overflow-y: auto;\r\n  \r\n   .ag-value-header {\r\n     font-size: 16px; \r\n     font-weight: bold;\r\n   }\r\n   .ag-value-section {\r\n     margin-left: 5px;\r\n   }\r\n   .ag-values-row {\r\n    margin: 12px 0 4px 0;\r\n    _align-self: center;\r\n    .ag-value-row {\r\n      overflow: hidden;\r\n      width: 150px;\r\n      .icon {\r\n        width: 32px;\r\n        height: 32px;\r\n        margin: 0;\r\n      }\r\n\r\n      .ag-value {\r\n        _height: 32px;\r\n        font-size: 24px;\r\n        _line-height: 32px;\r\n        _text-align: center;\r\n      }\r\n      .ag-value-label {\r\n        font-size: 12px;\r\n      }\r\n    }\r\n  }\r\n\r\n   .stats-container {\r\n     padding: 16px;\r\n   }\r\n \r\n   .temp-row,\r\n   .amb-temp-row {\r\n     margin-bottom: 8px;\r\n \r\n     md-icon {\r\n       width: 32px;\r\n       height: 32px;\r\n       margin: 0;\r\n     }\r\n \r\n     .temp-value {\r\n       height: 32px;\r\n       margin-left: 4px;\r\n       font-size: 32px;\r\n       font-weight: 500;\r\n       line-height: 36px;\r\n     }\r\n   }\r\n \r\n   .temp-row {\r\n     md-icon {\r\n       fill: #ed6d05;\r\n     }\r\n \r\n     .temp-value {\r\n       color: #ed6d05;\r\n     }\r\n   }\r\n \r\n   .amb-temp-row {\r\n     md-icon {\r\n       fill: #3498db;\r\n     }\r\n \r\n     .temp-value {\r\n       color: #3498db;\r\n     }\r\n   }\r\n \r\n   .temp-label {\r\n     margin-left: 4px;\r\n     color: #303c42;\r\n   }\r\n \r\n   .temp-ts {\r\n     color: #303c42;\r\n   }\r\n \r\n   ._ag-card {\r\n     /*background: white;\r\n     _margin-bottom: 10px;\r\n     margin: 8px;\r\n     border: 2px solid #fff;\r\n     border-radius: 16px;\r\n     position: relative;*/\r\n     margin-bottom: 10px;\r\n    _border: 2px solid #fff;\r\n    border-radius: 8px;\r\n    margin: 8px;\r\n    flex: 1 0 auto;\r\n    background-color: #fff;\r\n    box-shadow: 0 2px 4px -1px rgba(0,0,0,0.2), 0 4px 5px 0 rgba(0,0,0,0.14), 0 1px 10px 0 rgba(0,0,0,0.12);\r\n   }\r\n   .flex-auto {\r\n     flex: 1 0 auto !important;\r\n   }\r\n \r\n   #device-map {\r\n     height: 280px;\r\n \r\n     md-toast {\r\n       z-index: 2000;\r\n     }\r\n   }\r\n \r\n   .temp-history-container {\r\n     width: 100%;\r\n     _height: 260px;\r\n     padding-top: 0;\r\n \r\n     /*@media (min-width: $layout-breakpoint-sm) {\r\n       height: 280px;\r\n       padding-top: 8px;\r\n     }*/\r\n   }\r\n }\r\n \r\n .cellular-expand-button {\r\n   position: absolute;\r\n   top: 8px;\r\n   right: 8px;\r\n   z-index: 1000;\r\n   width: 32px !important;\r\n   min-width: 32px !important;\r\n   height: 32px !important;\r\n   min-height: 32px !important;\r\n   padding: 0 !important;\r\n   margin: 0 !important;\r\n   line-height: 20px;\r\n \r\n   md-icon,\r\n   ng-md-icon {\r\n     width: 20px;\r\n     min-width: 20px;\r\n     height: 20px;\r\n     min-height: 20px;\r\n     font-size: 20px;\r\n     color: rgba(0, 0, 0, .87);\r\n   }\r\n }\r\n \r\n #map-expand-button {\r\n   background-color: #fff;\r\n \r\n   md-icon,\r\n   ng-md-icon {\r\n     color: #000;\r\n   }\r\n }\r\n\r\n #get-location-button {\r\n   position: absolute;\r\n   right: 8px;\r\n   bottom: 20px;\r\n   z-index: 1000;\r\n   width: 32px;\r\n   min-width: 32px;\r\n   height: 32px;\r\n   min-height: 32px;\r\n   padding: 0 !important;\r\n   margin: 0 !important;\r\n   line-height: 20px;\r\n   background-color: #fff;\r\n \r\n   md-icon,\r\n   ng-md-icon {\r\n     width: 20px;\r\n     min-width: 20px;\r\n     height: 20px;\r\n     min-height: 20px;\r\n     font-size: 20px;\r\n     color: #000;\r\n   }\r\n }\r\n \r\n #cellular-chart-card {\r\n   _margin-top: 16px;\r\n   _margin-bottom: 16px;\r\n \r\n   .chart-heading {\r\n    margin: 10px 5px;\r\n    _align-self: center; \r\n    padding-bottom: 0;\r\n     _margin: 8px 0 0 8px;\r\n     font-weight: 600;\r\n     color: #303c42;\r\n   }\r\n }\r\n \r\n .tb-fullscreen-parent > #cellular-chart-card {\r\n   margin: 0;\r\n }\r\n "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
